'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleDate = function SimpleDate(_ref) {
  var date = _ref.date;
  return _react2.default.createElement(
    'span',
    null,
    new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
  );
};

SimpleDate.propTypes = { date: _propTypes2.default.number };

exports.default = SimpleDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/SimpleDate.js
// module id = 455
// module chunks = 0